// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9dab0c6d","978":"a13a3daf"}[chunkId] + ".chunk.js";
};